import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  onrenderColumnStack: {
    height: 25,
  },
  fontColor: {
    color: 'white',
  },
  contentColumnAlignCenter: {
    display: 'block',
    textAlign: 'center',
  },
  rowBaseStyle: { borderLeft: `5px solid transparent` },
  accessStatusContainer: {
  borderRadius: 5,
  height: 30,
  minWidth: 100,              
  width: 'fit-content',       
  padding: '10px',          
  display: 'inline-flex',    
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',     
}
}));
